var _g;

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import React from "react";

const SvgBookingcomIcon = _ref => {
  let {
    svgRef,
    title,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "8 8 15 15",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "surface1"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M18.1606 19.4486C18.1606 18.5926 18.8509 17.8994 19.7031 17.8994C20.5572 17.8994 21.2513 18.5926 21.2513 19.4486C21.2513 20.3047 20.5572 20.9998 19.7031 20.9998C18.8509 20.9998 18.1606 20.3047 18.1606 19.4486Z"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M12.6332 18.6719L10.4718 18.6709V16.0854C10.4718 15.5339 10.6868 15.2467 11.1591 15.1811H12.6332C13.6869 15.1811 14.3655 15.8453 14.3665 16.9173C14.3655 18.0183 13.7023 18.6719 12.6332 18.6719ZM10.4718 13.1933V11.0203C10.4718 10.4255 10.7234 10.1421 11.2777 10.1064H12.3835C13.3331 10.1064 13.8999 10.6733 13.8999 11.6229C13.8999 12.3468 13.5104 13.1933 12.4182 13.1933H10.4718ZM15.3951 14.2807L15.0037 14.0609L15.346 13.7688C15.7422 13.4285 16.4074 12.6611 16.4074 11.3356C16.4074 9.3082 14.8331 8 12.3999 8H9.30627C8.58517 8.02699 8.00771 8.61313 8 9.33905V20.8458H9.27446C9.27735 20.8477 9.27831 20.8458 9.28024 20.8477L12.4558 20.8458C15.1618 20.8458 16.9087 19.3727 16.9087 17.0918C16.9087 15.8646 16.3428 14.8148 15.3951 14.2807Z"
  }))));
};

const ForwardRef = /*#__PURE__*/React.forwardRef((props, ref) => /*#__PURE__*/React.createElement(SvgBookingcomIcon, _extends({
  svgRef: ref
}, props)));
export default __webpack_public_path__ + "static/media/bookingcom_icon.a48eead8.svg";
export { ForwardRef as ReactComponent };